import { gql } from '@apollo/client';

export const VariantCheckConfigTimeRangeFragment = gql`
  fragment VariantCheckConfigTimeRangeFragment on VariantCheckConfigurationTimeRange {
    useGraphSettings
    timeRangeSeconds
    operationCountThreshold
  }
`;

export const VariantCheckConfigIncludedVariantsFragment = gql`
  fragment VariantCheckConfigIncludedVariantsFragment on VariantCheckConfigurationIncludedVariants {
    useGraphSettings
    includedVariants
  }
`;

export const VariantCheckConfigExcludedClientsFragment = gql`
  fragment VariantCheckConfigExcludedClientsFragment on VariantCheckConfigurationExcludedClients {
    appendGraphSettings
    excludedClients {
      name
      version
    }
  }
`;

export const VariantCheckConfigExcludedOperationsFragment = gql`
  fragment VariantCheckConfigExcludedOperationsFragment on VariantCheckConfigurationExcludedOperations {
    appendGraphSettings
    excludedOperations {
      id
    }
    excludedOperationNames {
      name
      version
    }
  }
`;

export const VariantCheckConfigurationDownstreamVariantsFragment = gql`
  fragment VariantCheckConfigurationDownstreamVariantsFragment on VariantCheckConfigurationDownstreamVariants {
    blockingDownstreamVariants
  }
`;

export const VariantCheckConfigurationDowngradeChecksFragment = gql`
  fragment VariantCheckConfigurationDowngradeChecksFragment on VariantCheckConfigurationDowngradeChecks {
    useGraphSettings
    downgradeStaticChecks
    downgradeDefaultValueChange
  }
`;

export const VariantCheckConfigFragment = gql`
  fragment VariantCheckConfigFragment on VariantCheckConfiguration {
    id
    timeRangeConfig {
      ...VariantCheckConfigTimeRangeFragment
    }
    includedVariantsConfig {
      ...VariantCheckConfigIncludedVariantsFragment
    }
    excludedClientsConfig {
      ...VariantCheckConfigExcludedClientsFragment
    }
    excludedOperationsConfig {
      ...VariantCheckConfigExcludedOperationsFragment
    }
    downstreamVariantsConfig {
      ...VariantCheckConfigurationDownstreamVariantsFragment
    }
    downgradeChecksConfig {
      ...VariantCheckConfigurationDowngradeChecksFragment
    }
    operationsChecksEnabled
    updatedBy {
      id
      ... on User {
        fullName
      }
    }
    updatedAt
    createdAt
  }
  ${VariantCheckConfigTimeRangeFragment}
  ${VariantCheckConfigIncludedVariantsFragment}
  ${VariantCheckConfigExcludedClientsFragment}
  ${VariantCheckConfigExcludedOperationsFragment}
  ${VariantCheckConfigurationDownstreamVariantsFragment}
  ${VariantCheckConfigurationDowngradeChecksFragment}
`;
